import React from 'react';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import RouteRoundedIcon from '@mui/icons-material/RouteRounded';
import SensorsRoundedIcon from '@mui/icons-material/SensorsRounded';
import BatteryChargingFullRoundedIcon from '@mui/icons-material/BatteryChargingFullRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import TabbedPage from '../components/TabbedPage';
import ClientLocationsPage from './ClientLocationsPage';
import SiteVisitsPage from './SiteVisitsPage';
import LocationTrackingPage from './LocationTrackingPage';
import { LiveTripsTab, DeviceHealthTab, TrackingSettingsTab } from '../components/LocationTrackingTabs';

// Sites, the visits punched at them and the routes taken to reach them are one
// subject, so they share a screen instead of three sidebar rows.
const TABS = [
    { key: 'sites', label: 'Sites', icon: PlaceRoundedIcon, module: 'client-locations', render: () => <ClientLocationsPage /> },
    { key: 'visits', label: 'Site Visits', icon: StorefrontRoundedIcon, module: 'client-locations', render: () => <SiteVisitsPage /> },
    { key: 'routes', label: 'Route History', icon: RouteRoundedIcon, module: 'location-tracking', render: () => <LocationTrackingPage /> },
    { key: 'live', label: 'Live Trips', icon: SensorsRoundedIcon, module: 'location-tracking', render: () => <LiveTripsTab /> },
    { key: 'devices', label: 'Device Health', icon: BatteryChargingFullRoundedIcon, module: 'location-tracking', render: () => <DeviceHealthTab /> },
    { key: 'tracking-settings', label: 'Tracking Settings', icon: TuneRoundedIcon, module: 'location-tracking', render: () => <TrackingSettingsTab /> },
];

export default function FieldOperationsPage() {
    return <TabbedPage tabs={TABS} />;
}
